
import { RevIllustration } from '@ds/components/Illustration'

import translations from './Author.translations'

export default {
  components: {
    RevIllustration,
  },
  props: {
    quote: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    position: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: '',
    },
  },
  computed: {
    translations: () => translations,
  },
}
